import { InAppNotificationAppearance } from 'types';

export const getInAppToastAppearance = (
  notificationType?: InAppNotificationAppearance | null,
): 'success' | 'error' | 'info' | 'warning' => {
  switch (notificationType) {
    case 'info':
      return 'warning';
    case 'danger':
      return 'error';
    case 'success':
    default:
      return 'success';
  }
};
